import { render } from "./admin.vue?vue&type=template&id=6d80a7b8&scoped=true"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"

import "./admin.vue?vue&type=style&index=0&id=6d80a7b8&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d80a7b8"]])

export default __exports__